/* tslint:disable */
/* eslint-disable */
/**
 * Private UI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: ${project.version}
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface StbGroupEtcResponse
 */
export interface StbGroupEtcResponse {
    /**
     * 
     * @type {boolean}
     * @memberof StbGroupEtcResponse
     */
    addBpProfile: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof StbGroupEtcResponse
     */
    deviceCount: number | null;
    /**
     * 
     * @type {number}
     * @memberof StbGroupEtcResponse
     */
    deployedStbGroupCount: number | null;
    /**
     * 
     * @type {string}
     * @memberof StbGroupEtcResponse
     */
    superGroupName: string | null;
    /**
     * 
     * @type {string}
     * @memberof StbGroupEtcResponse
     */
    upgradeRuleName: string | null;
    /**
     * 
     * @type {string}
     * @memberof StbGroupEtcResponse
     */
    customFirmware1Version: string | null;
    /**
     * 
     * @type {string}
     * @memberof StbGroupEtcResponse
     */
    customFirmware2Version: string | null;
    /**
     * 
     * @type {string}
     * @memberof StbGroupEtcResponse
     */
    customFirmware3Version: string | null;
}

export function StbGroupEtcResponseFromJSON(json: any): StbGroupEtcResponse {
    return StbGroupEtcResponseFromJSONTyped(json, false);
}

export function StbGroupEtcResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): StbGroupEtcResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'addBpProfile': json['addBpProfile'],
        'deviceCount': json['deviceCount'],
        'deployedStbGroupCount': json['deployedStbGroupCount'],
        'superGroupName': json['superGroupName'],
        'upgradeRuleName': json['upgradeRuleName'],
        'customFirmware1Version': json['customFirmware1Version'],
        'customFirmware2Version': json['customFirmware2Version'],
        'customFirmware3Version': json['customFirmware3Version'],
    };
}

export function StbGroupEtcResponseToJSON(value?: StbGroupEtcResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'addBpProfile': value.addBpProfile,
        'deviceCount': value.deviceCount,
        'deployedStbGroupCount': value.deployedStbGroupCount,
        'superGroupName': value.superGroupName,
        'upgradeRuleName': value.upgradeRuleName,
        'customFirmware1Version': value.customFirmware1Version,
        'customFirmware2Version': value.customFirmware2Version,
        'customFirmware3Version': value.customFirmware3Version,
    };
}

